export function getUserAgent() {
  let ua = {},
    agent = navigator.userAgent,
    m
  ua.iPod = agent.indexOf("iPod") > -1
  ua.iPad = agent.indexOf("iPad") > -1 || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ua.iPhone = agent.indexOf("iPhone") > -1

  agent.indexOf("Android") > -1 && (ua.android = parseFloat(agent.slice(agent.indexOf("Android") + 8)))
  if (ua.android) {
    let match = navigator.userAgent?.toLowerCase()?.match(/android (.*?);/)
    ua.androidVer = match && match[1]?.replace("_", ".")
  }

  if (ua.iPad || ua.iPhone || ua.iPod) {
    ua.iOS = true

    let match = navigator.userAgent?.toLowerCase()?.match(/cpu iphone os (.*?) like mac os/)
    ua.iOSVer = match && match[1]?.replace("_", ".")
  }

  ua.wp = agent.indexOf("Windows Phone") > -1

  // 微信UA MicroMessenger后支持数字版本号和英文
  m = / MicroMessenger\/([A-Za-z0-9\.]+)/i.exec(agent)
  m && (ua.weixin = m[1])

  // 微信小程序
  ua.weixinminiprogram = (agent.match(/micromessenger/i) && agent.match(/miniprogram/i)) || window.__wxjs_environment === "miniprogram"

  // 手Q
  m = / QQ\/([0-9\.]+)/i.exec(agent)
  m && (ua.QQ = m[1])

  // 手空
  ua.qzone = agent.indexOf("Qzone/") > -1

  // 腾讯充值APP
  m = /TencentMidas\/([0-9\.]+)/i.exec(agent)
  m && (ua.midasAPP = m[1])

  // Safari浏览器
  if (/(iPhone)+[\S|\s]*(Version\/)[\S|\s]*Safari\//i.test(agent)) {
    m = /Safari\/([0-9\.]+)/i.exec(agent)
    m && (ua.iPhoneSafari = m[1])
  }

  // UC浏览器
  m = /UCBrowser\/([0-9\.]+)/i.exec(agent)
  m && (ua.UCBrowser = m[1])

  // 微视
  ua.WEISHI = agent.indexOf("_WEISHI_") > -1

  // 腾讯视频(乐玩分店)
  ua.tenVideo = agent.indexOf("QQLiveBrowser") > -1

  // 南极手机
  ua.nanji = agent.indexOf("com.tencent.southpole.appstore/NanJi") > -1

  // TIM
  m = /TIM\/([0-9\.]+)/i.exec(agent)
  m && (ua.TIM = m[1])

  // 快手app: 快手是 Kwai/版本 | 极速版是  ksNebula/版本
  m = /(Kwai|ksNebula)\/([0-9\.]+)/i.exec(agent)
  m && (ua.kuaishou = m[2])

  m = /(Kwai)\/([0-9\.]+)/i.exec(agent)
  m && (ua.Kwai = m[2])

  m = /(ksNebula)\/([0-9\.]+)/i.exec(agent)
  m && (ua.ksNebula = m[2])

  // QQ浏览器 (QQ、微信、腾讯视频App等应用的webview也会包含"MQQBrowser"，这里采用黑名单的方式来识别)
  if (!ua.weixin && !ua.weixinminiprogram && !ua.QQ && !ua.TIM && !ua.midasAPP && !ua.tenVideo && !ua.WEISHI) {
    m = /MQQBrowser\/([0-9\.]+)/i.exec(agent)
    m && (ua.MQQBrowser = m[1])
  }

  // 和平营地
  m = /GameHelper_20004\/([0-9\.]+)/i.exec(agent)
  m && (ua.hpyd = m[1])

  // 虎牙
  ua.huya = agent.indexOf("huya") > -1

  //MSDK浏览器
  ua.msdk = agent.indexOf("MSDK/") > -1 || location.href.indexOf("msdkEncodeParam=") > -1

  // 王者营地
  ua.wzyd = agent.indexOf("smobagamehelper") > -1

  // 斗鱼
  ua.douyu = agent.indexOf("Douyu") > -1

  // 在应用内
  ua.inApp = ua.WEISHI || ua.tenVideo || ua.TIM || ua.kuaishou || ua.midasAPP || ua.huya || ua.wzyd || ua.hpyd

  // 在第三方应用内
  ua.inThirdApp = ua.kuaishou || ua.huya || ua.douyu

  // 在QQ环境内，包括TIM
  ua.qqtim = ua.QQ || ua.TIM

  //游戏助手
  ua.gameHelper = agent.indexOf("GameHelper_") > -1
  return ua
}
